<template>
  <div>
    <Navbar v-if="$route.name == 'gdqsettings'"/>
    <!-- <Breadcrumb v-if="$route.name == 'gdqsettings'" /> -->
    <div class="col-12 px-0 mx-0 mt-2">
      <ul class="nav nav-tabs" role="tablist">
        <li class="nav-item" role="presentation">
          <button 
            class="nav-link" 
            :class="{active: activeTab === 0}"
            @click="activeTab = 0"
            type="button"
          >
            <fa-icon class="me-2" name="money-bill" />
            Pricing
          </button>
        </li>
        <li class="nav-item" role="presentation">
          <button 
            class="nav-link" 
            :class="{active: activeTab === 1}"
            @click="activeTab = 1"
            type="button"
          >
            <fa-icon class="me-2" name="envelope" />
            Invitations
          </button>
        </li>
        <li class="nav-item" role="presentation">
          <button 
            class="nav-link" 
            :class="{active: activeTab === 2}"
            @click="activeTab = 2"
            type="button"
          >
            <fa-icon class="me-2" name="tasks" />
            GDQ Questions
          </button>
        </li>
        <li class="nav-item" role="presentation">
          <button 
            class="nav-link" 
            :class="{active: activeTab === 3}"
            @click="activeTab = 3"
            type="button"
          >
            <fa-icon class="me-2" name="file-alt" />
            Questionnaire Texts
          </button>
        </li>
        <li class="nav-item" role="presentation">
          <button 
            class="nav-link" 
            :class="{active: activeTab === 4}"
            @click="activeTab = 4"
            type="button"
          >
            <fa-icon class="me-2" name="print" />
            Report Texts
          </button>
        </li>
        <li class="nav-item" role="presentation">
          <button 
            class="nav-link" 
            :class="{active: activeTab === 5}"
            @click="activeTab = 5"
            type="button"
          >
            <fa-icon class="me-2" name="check" />
            Certification
          </button>
        </li>
      </ul>
      <div class="tab-content mt-3">
        <div v-if="activeTab === 0" class="tab-pane show active">
          <div class="border-0 mx-0 ps-3 col-12">
            <div class="row">
              <div class="col-12">
                <div class="mb-3 d-flex align-items-center">
                  <label class="col-form-label" style="width: 33%; flex-shrink: 0;">VAT rate (%)</label>
                  <div style="width: 58%;">
                    <input 
                      id="gdq_vat" 
                      class="form-control"
                      v-model="gdq_vat"
                      @change="savepref('gdq_vat',gdq_vat)" 
                      autocomplete="off"
                    />
                  </div>
                </div>
              </div>
              <div class="col-12">
                <div class="mb-3 d-flex align-items-center">
                  <label class="col-form-label" style="width: 33%; flex-shrink: 0;">GDQ Report price per survey</label>
                  <div style="width: 58%;">
                    <input 
                      id="gdqreport_price" 
                      class="form-control"
                      v-model="gdqreport_price"
                      @change="savepref('gdqreport_price',gdqreport_price)" 
                      autocomplete="off"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="activeTab === 1" class="tab-pane show active">
          <div class="border-0 mx-auto px-0 col-12">
            <DefaultMailTexts />
          </div>
        </div>
        <div v-if="activeTab === 2" class="tab-pane show active">
          <div class="border-0 mx-auto px-0 col-12">
            <Maintenance tablename="g_questions" />
          </div>
        </div>
        <div v-if="activeTab === 3" class="tab-pane show active">
          <div class="border-0 mx-auto px-0 col-12">
            <Maintenance tablename="g_questionnairetexts" />
          </div>
        </div>
        <div v-if="activeTab === 4" class="tab-pane show active">
          <div class="border-0 mx-auto px-0 col-12">
            <Maintenance tablename="g_reporttexts" />
          </div>
        </div>
        <div v-if="activeTab === 5" class="tab-pane show active">
          <div class="border-0 ps-3 col-12">
            <div class="row">
              <div class="col-12">
                <div class="mb-3 d-flex align-items-center">
                  <label class="col-form-label" style="width: 16%; flex-shrink: 0;">Months before re-certification</label>
                  <div style="width: 8%;">
                    <input 
                      id="gdq_recertification_months" 
                      class="form-control"
                      v-model="gdq_recertification_months"
                      @change="savepref('gdq_recertification_months',gdq_recertification_months)" 
                      autocomplete="off"
                    />
                  </div>
                </div>
              </div>
              <div class="col-11">
                <div class="mb-3">
                  <label class="form-label">Popup text for re-certification</label>
                  <vue-editor 
                    v-model="gdq_recertification_text" 
                    :editorToolbar="editortoolbar" 
                    @text-change="savepref('gdq_recertification_text',gdq_recertification_text)"
                  ></vue-editor>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DefaultMailTexts from './DefaultMailTexts';
import Maintenance from './Maintenance';
import Navbar from './Navbar.vue';
// import Breadcrumb from './Breadcrumb.vue';
import VueEditor from "./CustomControls/VueEditor.vue";

var editortools = [
  [{ font: [] }],
  [{ header: [false, 1, 2, 3, 4, 5, 6] }],
  [{ size: ["small", false, "large", "huge"] }],
  ["bold", "italic", "underline", "strike"],
  [
    { align: "" },
    { align: "center" },
    { align: "right" },
    { align: "justify" }
  ],
  [{ header: 1 }, { header: 2 }],
  [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
  [{ script: "sub" }, { script: "super" }],
  [{ indent: "-1" }, { indent: "+1" }],
  [{ color: [] }, { background: [] }],
  ['link'],
];
export default {
  name: 'GDQSettings',
  mounted() {
    this.prefs_get();
  },
  components: {
    Maintenance,
    DefaultMailTexts,
    Navbar,
    // Breadcrumb,
    VueEditor,
  },
  data: function() {
    return {
      activeTab: 0,
      editortoolbar: editortools,
      gdqreport_price: 0,
      gdq_vat: 0,
      gdq_recertification_months: 36,
      gdq_recertification_text: 'You must re-certify!',
    }
  },
  methods: {
    savepref(key,value) {
      if (key.indexOf('_date') != -1) {
        value = this.format_date(value);
      }
      this.$store.dispatch('syspref_save', { key: key,value: value });
    },
    prefs_get() {
      this.$store.dispatch('syspref_fetch', { key: 'gdqreport_price' })
      .then((resp) => {
        this.gdqreport_price = resp.data.value;
      });
      this.$store.dispatch('syspref_fetch', { key: 'gdq_vat' })
      .then((resp) => {
        this.gdq_vat = resp.data.value;
      });
      this.$store.dispatch('syspref_fetch', { key: 'gdq_recertification_months' })
      .then((resp) => {
        this.gdq_recertification_months = resp.data.value;
      });
      this.$store.dispatch('syspref_fetch', { key: 'gdq_recertification_text' })
      .then((resp) => {
        this.gdq_recertification_text = resp.data.value;
      });
    },
  },
}
</script>
<style>
</style>
